import Lottie from 'react-lottie';
import shipingContainer from 'assets/lottie/container-ship.json';
import * as React from 'react';

interface Props {
  children?: React.ReactNode;
  className?: string;
}

export const Loader: React.FC<Props> = (props) => {
  const { className, children } = props;
  return (
    <div className={`bg-white py-2 ${className}`}>
      <Lottie
        options={{ loop: true, autoplay: true, animationData: shipingContainer }}
        height={150}
      />
      {children}
    </div>
  );
};
Loader.displayName = 'Loader';
